import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import { BsXCircle } from "react-icons/bs";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/datatable.scss";
import "../../../../components/common/css/modal.scss";
import PageShell from "../../../../components/layout/PageShell";
import PageHead from "../../../../components/layout/PageHead";

const Sociallist = () => {
  const [query, setQuery] = useState("");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);

  //   const search = (data) => {
  //     return data?.filter(
  //       (item) =>
  //         item?.category_name?.toLowerCase()?.includes(query) ||
  //         item?.category_title?.toLowerCase()?.includes(query) ||
  //         item?.category_description?.toLowerCase()?.includes(query)
  //     );
  //   };

  //

  const fetchlinksdata = () => {
    setLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-social-media-links",
    };

    axios(config)
      .then(function (response) {
        
        setData(response.data.data);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchlinksdata();
  }, []);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/social-media-links/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
            <Link
              to={`/social-media-links/edit/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="editButton">
                <EditOutlinedIcon />
              </div>
            </Link>
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 50 },

    {
      field: "facebook_link",
      headerName: "Facebook",
      flex: 1,
      minWidth: 170,
    },
    {
      field: "instagram_link",
      headerName: "Instagram",
      flex: 1,
      minWidth: 170,
    },
    {
      field: "gmail_link",
      headerName: "Gmail",
      flex: 1,
      minWidth: 170,
    },
    {
      field: "linkedin_link",
      headerName: "Linkedin",
      flex: 1,
      minWidth: 170,
    },
    {
      field: "twitter_link",
      headerName: "Twitter",
      flex: 1,
      minWidth: 170,
    },
  ];

  return (
    <PageShell><PageHead title="Social links" /><div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input type="text" placeholder="Search..." />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Social Links</h5>
        <div></div>
      </div>
      {/* {open && (
        <Modal
          open={open}
          center
          onClose={onCloseModal}
          closeOnOverlayClick={false}
          classNames={{
            modal: "customModal",
          }}
        >
          <div className="container-modal">
            <div className="modal-header">
              <BsXCircle color={"#dc3545"} size={"3em"} />
              <h4>Are you sure?</h4>
            </div>
            <div className="confirmation-text">
              Do you really want to delete these tasks ?
            </div>
            <div className="button-container">
              <button className="cancel-button" onClick={() => onCloseModal()}>
                Cancel
              </button>
              <button
                className="confirmation-button"
                onClick={() => deleteTeamData()}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal>
      )} */}

      <DataGrid
        autoHeight
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        
      />
    </div></PageShell>
  );
};

export default Sociallist;
